var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('a',{directives:[{name:"show",rawName:"v-show",value:(_vm.visible),expression:"visible"}],staticClass:"bottom-right",on:{"click":_vm.scrollTop}},[_c('a',{staticClass:"main-scroll-icon"},[_c('i-icon',{attrs:{"icon":"fa6-solid:angle-up"}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }